import { computed } from 'vue';
import { usePermissions } from './usePermissions';

export function useChevaulAccess() {
  const { hasRole } = usePermissions();

  const canAddCheval = computed(() => {
    const allowedRoles = ['SUPER_ADMIN', 'ADMIN', 'CHEF_BUREAU', 'DIRECTEUR', 'RESPONSABLE_HARAS'];
    return hasRole(allowedRoles);
  });

  return {
    canAddCheval,
  };
}
